export default "__VITE_ASSET__f3fbcbcb__"